import { AppBar, Tab, Tabs } from '@mui/material';
import { Page, PageTitle } from '../../../components';
import { useEffect, useState } from 'react';
import { AvailableSpecHomesTab } from './available-spec-homes-tab';
import { PlanFinder } from './plan-finder';
import { SellersAgent } from './sellers-agent';

export const enum salesReportTabs {
  availableSpecHomes,
  planFinder,
  sellersAgentReport
}

export const SalesReportsPage = () => {
  const salesReportTabLinks = [
    {
      name: 'Available Spec Homes',
      url: `/sales/sales-tools/reports/available-spec-homes`,
      value: salesReportTabs.availableSpecHomes
    },
    {
      name: 'Plan Finder',
      url: `/sales/sales-tools/reports/plan-finder`,
      value: salesReportTabs.planFinder
    },
    {
      name: 'Sellers Agent',
      url: `/sales/sales-tools/reports/sellers-agent-report`,
      value: salesReportTabs.sellersAgentReport
    }
  ];

  const [selectedTab, setSelectedTab] = useState<salesReportTabs>(
    salesReportTabs.availableSpecHomes
  );

  // Set Selected Tab based on page URL
  // not currently used at the moment, but setup in case we want to switch the tabs to links
  useEffect(() => {
    if (window.location.href.includes('available-spec-homes')) {
      setSelectedTab(salesReportTabs.availableSpecHomes);
    }
    if (window.location.href.includes('plan-finder')) {
      setSelectedTab(salesReportTabs.planFinder);
    }
    if (window.location.href.includes('sellers-agent-report')) {
      setSelectedTab(salesReportTabs.sellersAgentReport);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  return (
    <Page pageHasStickyHeaders title="Reports | Sales" printOrientation="landscape">
      <PageTitle title="Reports" />
      <AppBar position="static" color="default" component="div" className="tabBar">
        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_, value) => {
            setSelectedTab(value);
          }}
          variant="scrollable"
          allowScrollButtonsMobile
        >
          {salesReportTabLinks.map(link => {
            return (
              <Tab
                value={link.value}
                key={link.value}
                id={`${link.name}`}
                aria-controls={`${link.name}`}
                label={link.name}
              />
            );
          })}
        </Tabs>
      </AppBar>
      {selectedTab === salesReportTabs.availableSpecHomes && <AvailableSpecHomesTab />}
      {selectedTab === salesReportTabs.planFinder && <PlanFinder />}
      {selectedTab === salesReportTabs.sellersAgentReport && <SellersAgent />}
    </Page>
  );
};
